import React, { useState, useEffect } from 'react';
import { useSalon } from '../context/SalonContext';
import { FiX, FiInfo } from 'react-icons/fi';
import './AnnouncementPopup.css';

const AnnouncementPopup = () => {
    const { salonInfos } = useSalon();
    const [isMinimized, setIsMinimized] = useState(true); // Par défaut réduit
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (!salonInfos) return;

        if (salonInfos.popup_active) {
            const hasSeen = sessionStorage.getItem('hasSeenAnnouncement_' + salonInfos.updated);

            // Si pas vu, on ouvre le popup (non réduit)
            if (!hasSeen) {
                // Petit délai pour laisser le temps de charger la page tranquille
                setTimeout(() => setIsMinimized(false), 800);
            } else {
                setIsMinimized(true);
            }
            setIsLoaded(true);
        } else {
            setIsLoaded(false);
        }
    }, [salonInfos]);

    const handleClose = (e) => {
        e?.stopPropagation();
        setIsMinimized(true);
        if (salonInfos) {
            sessionStorage.setItem('hasSeenAnnouncement_' + salonInfos.updated, 'true');
        }
    };

    const handleOpen = () => {
        setIsMinimized(false);
    };

    if (!isLoaded || !salonInfos?.popup_active) return null;

    return (
        <>
            {/* Overlay (si ouvert) */}
            {!isMinimized && (
                <div className="announcement-overlay" onClick={handleClose}>
                    <div className="announcement-card" onClick={e => e.stopPropagation()}>
                        <button className="announcement-close" onClick={handleClose} aria-label="Réduire">
                            <FiX />
                        </button>

                        <div className="announcement-header">
                            <div className="announcement-icon">📢</div>
                            <h3>{salonInfos.popup_title || "Information Importante"}</h3>
                        </div>

                        <div className="announcement-body">
                            {salonInfos.popup_content ? (
                                salonInfos.popup_content.split('\n').map((line, index) => (
                                    <p key={index}>{line}</p>
                                ))
                            ) : (
                                <p>Aucun contenu.</p>
                            )}
                        </div>

                        <button className="announcement-cta" onClick={handleClose}>
                            C'est noté !
                        </button>
                    </div>
                </div>
            )}

            {/* Bouton Flottant (si réduit) */}
            {isMinimized && (
                <div className="announcement-floating-btn" onClick={handleOpen} title="Voir l'annonce">
                    <span className="floating-icon">📢</span>
                    <span className="floating-text">Info</span>
                </div>
            )}
        </>
    );
};

export default AnnouncementPopup;
